import { useState } from "react"

const STORAGE_PREFIX = "mc:seen:"

/**
 * Tracks whether the user has already seen a given piece of onboarding
 * (design principle #4: explain the non-obvious the first time, never
 * again). `key` should be a stable, unique id per screen/feature, e.g.
 * "console-command-history".
 */
export function useFirstVisit(key: string): [boolean, () => void] {
  const storageKey = STORAGE_PREFIX + key
  const [isFirstVisit, setIsFirstVisit] = useState(() => localStorage.getItem(storageKey) === null)

  const dismiss = () => {
    localStorage.setItem(storageKey, "seen")
    setIsFirstVisit(false)
  }

  return [isFirstVisit, dismiss]
}
